import { render, staticRenderFns } from "./AddBusiness.vue?vue&type=template&id=3fe217f4&scoped=true&"
import script from "./AddBusiness.vue?vue&type=script&lang=js&"
export * from "./AddBusiness.vue?vue&type=script&lang=js&"
import style0 from "./AddBusiness.vue?vue&type=style&index=0&id=3fe217f4&lang=less&scoped=true&"
import style1 from "./AddBusiness.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe217f4",
  null
  
)

export default component.exports